import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState()
  ],
  state: {
    serverHttpUrl: null,
    token: null,
    user: null,
    email: null,
    isUserLoggedIn: false,
    currentProjectName: null,
    currentProjectId: null
  },
  mutations: {
    setServerHttpUrl (state, url) {
      state.serverHttpUrl = url
    },
    setToken (state, token) {
      state.token = token
    },
    setUser (state, user) {
      state.user = user
    },
    setCurrentProjectName (state, projectName) {
      state.currentProjectName = projectName
    },
    setEmail (state, email) {
      state.email = email
    },
    setCurrentProjectId (state, projectId) {
      state.currentProjectId = projectId;
    }
  },
  actions: {
    setServerHttpUrl ({commit}, url) {
      commit('setServerHttpUrl', url)
    },
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setUser ({commit}, user) {
      commit('setUser', user)
    },
    setCurrentProjectName ({commit}, projectName) {
      commit('setCurrentProjectName', projectName)
    },
    setEmail ({commit}, email) {
      commit('setEmail', email)
    },
    setCurrentProjectId ({commit}, projectId) {
      commit('setCurrentProjectId', projectId);
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js